import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaioutstationcab() {



  const cardData = {
    keyword: " Mumbai Outstation Cabs",

     "headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai outstation cab services, making long-distance travel smooth, convenient, and stress-free. Whether you are planning a weekend getaway, family vacation, business trip, or group travel, our professional drivers and well-maintained vehicles ensure a safe and enjoyable journey. We provide flexible travel options including one-way trips, round trips, and customized itineraries with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and premium cars suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for outstation travel from Mumbai to popular destinations across Maharashtra and beyond.",

  "topPlaces": [
   {
    "title": "Lonavala",
    "description": "Lonavala is a popular hill station located near Mumbai, known for its lush green valleys, waterfalls, and scenic viewpoints. Travelers can explore attractions like Tiger Point, Bhushi Dam, and Rajmachi Fort while enjoying the refreshing mountain climate."
  },
  {
    "title": "Khandala",
    "description": "Khandala is a picturesque hill station famous for its natural beauty and tranquil surroundings. Visitors can enjoy panoramic views, trekking trails, and beautiful landscapes, making it an ideal weekend getaway from Mumbai."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is a charming hill station known for its strawberry farms, breathtaking viewpoints, and pleasant weather. Popular attractions include Arthur’s Seat, Venna Lake, and Pratapgad Fort."
  },
  {
    "title": "Pune",
    "description": "Pune is a vibrant city that blends history, culture, and modern attractions. Visitors can explore historical landmarks such as Shaniwar Wada, Aga Khan Palace, and enjoy the city’s thriving food and shopping scene."
  },
  {
    "title": "Nashik",
    "description": "Nashik is a renowned pilgrimage and wine tourism destination. Travelers can visit sacred temples, enjoy vineyard tours, and experience the city's rich cultural heritage along the banks of the Godavari River."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is a coastal town famous for its clean beaches, historic forts, and relaxed atmosphere. It is a favorite destination for beach lovers seeking a peaceful escape from Mumbai’s busy lifestyle."
  },
  {
    "title": "Matheran",
    "description": "Matheran is India’s smallest hill station and is unique for being an automobile-free destination. Visitors can enjoy scenic viewpoints, horse rides, toy train journeys, and a peaceful natural environment."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi is one of India's most important spiritual destinations, attracting millions of devotees every year. It is best known as the home of Sai Baba and offers a deeply spiritual and serene experience."
  },
  {
    "title": "Igatpuri",
    "description": "Igatpuri is a beautiful hill station nestled in the Western Ghats, known for its misty mountains, waterfalls, and trekking opportunities. It is especially popular during the monsoon season."
  },
  {
    "title": "Goa",
    "description": "Goa is India's premier beach destination, famous for its stunning coastline, vibrant nightlife, Portuguese heritage, and water sports. It offers a perfect blend of relaxation, adventure, and cultural experiences."
  }
  ],



   services: [
  {
    name: "Mumbai Outstation Cabs",
    description: "Mumbai outstation cabs provide reliable and comfortable travel solutions for long-distance journeys from Mumbai to popular destinations across Maharashtra and nearby states. Whether you are planning a family trip, corporate travel, or weekend getaway, these cabs ensure a smooth and stress-free ride. Professional drivers, clean vehicles, and flexible pickup options make the journey convenient. Travelers can choose from sedan, SUV, and luxury vehicles based on their needs. With 24x7 availability and easy booking, it is the perfect choice for outstation travel."
  },
  {
    name: "Outstation Cab Service Mumbai",
    description: "Outstation cab service Mumbai offers well-managed transportation for long-distance travel with a focus on safety and comfort. This service is ideal for individuals, families, and corporate clients looking for reliable intercity travel. Vehicles are well-maintained and driven by experienced chauffeurs. Flexible pickup locations and customizable travel plans enhance convenience. Customers can enjoy a seamless journey with transparent pricing and dedicated support. It ensures a hassle-free travel experience."
  },
  {
    name: "Mumbai Outstation Taxi Service",
    description: "Mumbai outstation taxi service is designed for travelers seeking dependable and comfortable rides to destinations outside the city. With a fleet of clean and modern vehicles, this service ensures smooth highway travel. Door-to-door pickup and drop provide maximum convenience. Drivers are trained for long-distance routes, ensuring safety throughout the journey. Suitable for personal and business travel alike. It guarantees a reliable and enjoyable trip."
  },
  {
    name: "Outstation Car Rental Mumbai",
    description: "Outstation car rental Mumbai provides flexible travel options for customers who want customized intercity journeys. Travelers can choose from a wide range of vehicles including sedans, SUVs, and luxury cars. This service is perfect for vacations, business trips, and family outings. Easy booking process and transparent pricing make it user-friendly. Vehicles are maintained for long-distance performance. It ensures comfort and convenience throughout the journey."
  },
  {
    name: "One Way Outstation Cab Mumbai",
    description: "One way outstation cab Mumbai is a cost-effective solution for travelers who require a single-side journey without return charges. This option is ideal for those relocating or planning extended stays at their destination. Customers benefit from affordable pricing, flexible timings, and comfortable vehicles. Professional drivers ensure timely and safe travel. Easy booking and instant confirmation add convenience. It is a smart choice for budget-friendly travel."
  },
  {
    name: "Mumbai Outstation Taxi Booking",
    description: "Mumbai outstation taxi booking allows customers to reserve their ride quickly with instant confirmation and flexible scheduling. Travelers can select vehicle type, pickup point, and travel date according to their preference. Online booking ensures transparency and ease of use. Secure payment options and customer support enhance the experience. It is the most convenient way to plan outstation travel from Mumbai."
  },
  {
    name: "Mumbai to Outstation Cab",
    description: "Mumbai to outstation cab service connects travelers to multiple destinations with comfort and reliability. This service is suitable for weekend trips, pilgrimages, and business travel. Vehicles are equipped for long-distance journeys with professional drivers ensuring safety. Flexible routes and stopovers make the journey enjoyable. Multiple vehicle options cater to different group sizes. It offers a smooth and enjoyable travel experience."
  },
  {
    name: "Taxi Service in Mumbai for Outstation",
    description: "Taxi service in Mumbai for outstation provides dependable travel solutions for customers looking to travel beyond city limits. This service ensures door-to-door pickup, well-maintained vehicles, and experienced drivers. It is ideal for families, tourists, and corporate travelers. Flexible travel schedules and competitive pricing add convenience. It ensures a comfortable and stress-free journey."
  },
  {
    name: "Best Outstation Cab Service Mumbai",
    description: "Best outstation cab service Mumbai focuses on delivering premium travel experience with high-quality vehicles and professional drivers. This service ensures safety, punctuality, and comfort for every journey. Customers can choose from a variety of vehicles based on their needs. Transparent pricing and excellent customer support build trust. It is the preferred choice for reliable outstation travel."
  },
  {
    name: "Cheap Outstation Cab Mumbai",
    description: "Cheap outstation cab Mumbai offers affordable travel options without compromising on safety and comfort. This service is ideal for budget-conscious travelers who want reliable transportation. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. Professional drivers provide smooth and safe travel. It is perfect for cost-effective long-distance trips."
  },
  {
    name: "Mumbai Outstation Cab Booking Online",
    description: "Mumbai outstation cab booking online provides a quick and easy way to reserve your cab from anywhere. Customers can choose vehicle type, travel date, and pickup location within minutes. Online platforms offer secure payment and instant confirmation. It ensures availability of cabs even during peak travel times. Dedicated support adds to convenience. It is the simplest way to book an outstation cab."
  },
  {
    name: "Mumbai Airport Outstation Cab",
    description: "Mumbai airport outstation cab service offers direct transfers from the airport to various outstation destinations. This service is ideal for travelers arriving in Mumbai and heading to nearby cities or tourist spots. Timely pickups and professional drivers ensure a smooth journey. Comfortable vehicles provide a relaxing travel experience. It is perfect for seamless airport-to-destination travel."
  },
  {
    name: "Innova Outstation Cab Mumbai",
    description: "Innova outstation cab Mumbai is a popular choice for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating, luggage space, and smooth ride quality. It is ideal for long-distance trips and multi-day journeys. Professional drivers ensure safe travel across highways. It provides a premium and reliable travel experience."
  },
  {
    name: "Ertiga Outstation Taxi Mumbai",
    description: "Ertiga outstation taxi Mumbai is suitable for small groups and families looking for an affordable yet comfortable ride. This vehicle offers good mileage and spacious seating for long journeys. It is perfect for budget-friendly travel with added convenience. Drivers are experienced in long-distance routes. It ensures a smooth and enjoyable journey."
  },
  {
    name: "Sedan Outstation Cab Mumbai",
    description: "Sedan outstation cab Mumbai is ideal for couples and small families seeking economical travel options. Sedans provide smooth driving experience and comfortable seating for long-distance journeys. This option is widely preferred for its affordability and convenience. Professional drivers ensure safe travel. It is perfect for budget-friendly outstation trips."
  },
  {
    name: "SUV Outstation Taxi Mumbai",
    description: "SUV outstation taxi Mumbai offers extra space and comfort for group travel and long journeys. SUVs are suitable for hilly areas and highways, providing better performance and stability. This option is ideal for families, friends, and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable and premium experience."
  },
  {
    name: "Luxury Outstation Cab Mumbai",
    description: "Luxury outstation cab Mumbai provides high-end travel experience with premium vehicles and top-class amenities. This service is ideal for business executives, VIP travel, and special occasions. Vehicles offer superior comfort, spacious interiors, and smooth ride quality. Professional chauffeurs ensure a premium journey. It is perfect for luxury long-distance travel."
  },
  {
    name: "Corporate Outstation Cab Mumbai",
    description: "Corporate outstation cab Mumbai is designed for business travel with a focus on punctuality, professionalism, and comfort. This service is ideal for corporate clients, meetings, and employee travel. Well-maintained vehicles and trained drivers ensure reliability. Flexible booking and billing options suit corporate needs. It provides a seamless and efficient travel solution."
  }
],

tableData: [
  ["Mumbai Outstation Cabs", "Outstation Cab Service Mumbai"],
  ["Mumbai Outstation Taxi Service", "Outstation Car Rental Mumbai"],
  ["One Way Outstation Cab Mumbai", "Mumbai Outstation Taxi Booking"],
  ["Mumbai to Outstation Cab", "Taxi Service in Mumbai for Outstation"],
  ["Best Outstation Cab Service Mumbai", "Cheap Outstation Cab Mumbai"],
  ["Mumbai Outstation Cab Booking Online", "Mumbai Airport Outstation Cab"],
  ["Innova Outstation Cab Mumbai", "Ertiga Outstation Taxi Mumbai"],
  ["Sedan Outstation Cab Mumbai", "SUV Outstation Taxi Mumbai"],
  ["Luxury Outstation Cab Mumbai", "Corporate Outstation Cab Mumbai"]
],


  whychoose: [
  {
    WhyChooseheading: "Comfortable Long Distance Travel",
    WhyChoosedescription: "Royal Route Cabs offers reliable Mumbai outstation cab services for a smooth and comfortable journey, ideal for family vacations, group trips, and weekend getaways."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance routes from Mumbai, ensuring safe driving, smooth navigation, and timely travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Royal Route Cabs provides clear and transparent pricing for Mumbai outstation cab bookings. Customers receive full fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai outstation cab service operates 24/7. Whether you plan an early morning departure or overnight journey, Royal Route Cabs ensures reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and relaxing long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Royal Route Cabs offers flexible travel options including one-way cab service, round-trip bookings, and customized travel packages from Mumbai to various destinations."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, luxury SUVs, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by many travelers for Mumbai outstation cab bookings due to punctual drivers, comfortable vehicles, and professional service."
  }
]
};   

const faqData = [
  {
    question: "Do you provide Mumbai outstation cab service?",
    answer: "Yes, Royal Route Cabs provides reliable outstation cab services from Mumbai for one-way and round-trip travel."
  },
  {
    question: "Which destinations do you cover from Mumbai?",
    answer: "We cover popular destinations like Pune, Goa, Nashik, Lonavala, Mahabaleshwar, Shirdi, and many more across Maharashtra and India."
  },
  {
    question: "Is cab service available 24 hours?",
    answer: "Yes, our Mumbai outstation cab service operates 24/7."
  },
  {
    question: "Which vehicles are available for outstation travel?",
    answer: "Royal Route Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, luxury SUVs, and Tempo Travellers."
  },
  {
    question: "Can I book a one-way cab?",
    answer: "Yes, we provide both one-way and round-trip cab services from Mumbai."
  },
  {
    question: "Are vehicles air-conditioned?",
    answer: "Yes, all vehicles are fully air-conditioned for comfortable travel."
  },
  {
    question: "Can I book the cab online?",
    answer: "Yes, customers can easily book Mumbai outstation cabs online or through phone booking."
  },
  {
    question: "Do you provide doorstep pickup?",
    answer: "Yes, we provide doorstep pickup from homes, hotels, and offices across Mumbai."
  },
  {
    question: "Is advance booking required?",
    answer: "Advance booking is recommended especially during weekends and holiday seasons."
  },
  {
    question: "Are vehicles sanitized regularly?",
    answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Sharma",
    feedback: "The outstation ride from Mumbai with Royal Route Cabs was extremely smooth and comfortable. Driver was punctual and well-mannered throughout the journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Mehta",
    feedback: "Had a wonderful experience traveling out of Mumbai. The cab was clean, well-maintained, and the entire trip felt safe and relaxing with Royal Route Cabs.",
    rating: 5
  },
 
  
];
























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Outstation Cabs",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-outstation-cabs.jpg", // replace with actual image URL if different
  "description": "Book reliable and affordable Mumbai outstation cab services with Royal Route Cabs. Offering one-way and round-trip taxi services from Mumbai to all major destinations with sedan, SUV, Innova, and luxury vehicles. 24x7 service with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-outstation-cabs"
  }
};





  return (
    <div>

<Helmet>
  <title>Mumbai Outstation Cabs | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai outstation cabs with Royal Route Cabs. Affordable one-way & round-trip taxi services from Mumbai with sedan, SUV, Innova & luxury cars. 24x7 service with trusted drivers."
  />

  <meta
    name="keywords"
    content="mumbai outstation cabs, outstation cab service mumbai, mumbai outstation taxi service, outstation car rental mumbai, one way outstation cab mumbai, mumbai outstation taxi booking, mumbai to outstation cab, taxi service in mumbai for outstation, best outstation cab service mumbai, cheap outstation cab mumbai, mumbai outstation cab booking online, mumbai airport outstation cab, innova outstation cab mumbai, ertiga outstation taxi mumbai, sedan outstation cab mumbai, suv outstation taxi mumbai, luxury outstation cab mumbai, corporate outstation cab mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/1.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaioutstationcab;